// src/components/WeatherCard.ts
import "./WeatherCard.css";
import {
  freshStoredLocationCoordinates,
  locationCoordinates,
  refreshLocationIfAllowed,
} from "./UserLocation";

const NEAR_ME_RE = /\b(near me|my area|where i am|my location|locally)\b/i;

export async function renderWeatherCard(container: HTMLElement, query: string) {
  container.innerHTML = `<div class="card-container weather-card">Loading weather...</div>`;

  let q = query.toLowerCase().trim();
  if (q === "weather") q = "";

  let location = "";
  if (!NEAR_ME_RE.test(q)) {
    location = q.replace("weather in", "").trim();
  }

  if (!location) {
    location = freshStoredLocationCoordinates();

    if (!location) {
      const refreshed = await refreshLocationIfAllowed();
      if (refreshed) location = locationCoordinates(refreshed);
    }
  }

  if (!location) {
    container.innerHTML = `
      <div class="card-container weather-card">
        <p>Please allow location access or use “Use my location” on the forecast.</p>
      </div>
    `;
    return;
  }

  try {
    const res = await fetch(
      `https://api.ayesearch.com/api/ai/weather/?q=${encodeURIComponent(location)}`,
    );

    const data = await res.json();

    if (data.error) {
      container.innerHTML = `
        <div class="card-container weather-card">
          <p>${data.error.message}</p>
        </div>
      `;
      return;
    }

    const current = data.current;
    const loc = data.location;

    container.innerHTML = `
      <div class="card-container weather-card">
        <div class="card-title">Weather</div>

        <div class="weather-main">
          <img src="${current.condition.icon}" class="weather-icon" />
          <div class="weather-temp">${current.temp_f}°F</div>
          <div class="weather-condition">${current.condition.text}</div>
        </div>

        <div class="weather-meta">
          <span>Feels like: ${current.feelslike_f}°F</span>
          <span>Humidity: ${current.humidity}%</span>
          <span>Wind: ${current.wind_mph} mph</span>
          <span class="weather-location">${loc.name}, ${loc.region}, ${loc.country}</span>
        </div>
      </div>
    `;
  } catch {
    container.innerHTML = `
      <div class="card-container weather-card">
        <p>Unable to load weather data.</p>
      </div>
    `;
  }
}
